import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import queryString from 'query-string'
import { orgContactScheme } from 'models'
import { notification, logError } from 'redux/modules/app'
import { passwords as passwordsApi } from 'redux/modules/api'
import config from 'config'

function decorator() {
  return ComposedComponent => {
    @connect(null, { notification, logError, push, ...passwordsApi })
    class Passwords extends Component {
      static propTypes = {
        resetPassword: PropTypes.func.isRequired,
        confirmOrganizationContactRegistration: PropTypes.func.isRequired,
        resetRequest: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        push: PropTypes.func.isRequired
      }

      handleResetRequest = fields =>
        this.props
          .resetRequest(fields.email)
          .then(this.handleSent)
          .catch(this.handleError)

      handleResetPassword = (fields = {}) => {
        const query = queryString.parse(get(this.props, 'location.search'))
        const authCode = get(query, 'authorizationCode')

        return this.props
          .resetPassword({ value: fields.password }, authCode)
          .catch(this.handleError)
      }

      handleConfirmOrganizationContactRegistration = (fields = {}) => {
        const { configuration } = this.props
        const query = queryString.parse(get(this.props, 'location.search'))
        const authCode = get(query, 'authorizationCode')
        const data = orgContactScheme(fields, configuration)

        return this.props.confirmOrganizationContactRegistration(data, authCode)
          .catch(this.handleError)
      }

      handleSent = () => {
        this.props.notification('Email with instructions has been sent', {
          status: 'success',
          intlKey: 'notifications.email_with_instructions_has_been_sent'
        })
        this.props.push(`${config.publicPath}/`)
      }

      handleError = err => {
        this.props.logError(err, {
          authCode: true
        })

        throw err
      }
      render() {
        return (
          <ComposedComponent
            {...this.props}
            resetRequest={this.handleResetRequest}
            onResetPassword={this.handleResetPassword}
            onConfirmOrganizationContactRegistration={this.handleConfirmOrganizationContactRegistration}
          />
        )
      }
    }
    return Passwords
  }
}

export default decorator
